var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.exerciseID && _vm.formationID && _vm.storyID)?_c('StoryComponent',{attrs:{"idFormation":_vm.formationID,"idExercice":_vm.exerciseID,"idStory":_vm.storyID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }